// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as RecordActionDecoder from "./RecordActionDecoder.bs.js";

function eventInterpretor(e, cb) {
  var payload = e.data;
  if (payload.messageType === "record action") {
    return Curry._1(cb, (function (param) {
                  return RecordActionDecoder.getDecodedRecordAction(payload);
                }));
  }
  
}

function useRecordActionEvents(param) {
  var match = React.useState(function () {
        return /* Blank */1;
      });
  var setState = match[1];
  React.useEffect((function () {
          var $$document = window;
          $$document.addEventListener("message", (function (e) {
                  return eventInterpretor(e, setState);
                }));
          return (function (param) {
                    $$document.removeEventListener("message", (function (e) {
                            return eventInterpretor(e, setState);
                          }));
                    
                  });
        }), []);
  var setStateAction = function (actionType) {
    return Curry._1(setState, (function (param) {
                  return actionType;
                }));
  };
  return [
          match[0],
          setStateAction
        ];
}

export {
  eventInterpretor ,
  useRecordActionEvents ,
  
}
/* react Not a pure module */
